import { useState } from "react";
import { useNavigate } from "react-router-dom";
import loginIllustration from "../assets/images/login-illustration.svg";

function RecoverForm() {
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({ email: "" });
  const [errors, setErrors] = useState({ email: "", });
  const [serverError, setServerError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }

    if (serverError) setServerError("");
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { email: "" };

    if (!formData.email) {
      newErrors.email = "O e-mail é obrigatório";
      valid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Formato de e-mail inválido";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    const body = {
      email: formData.email,
    };

    try {
      const response = await fetch(
        "https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/user/forgot-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setSuccessMessage(result.msg || "Link de recuperação enviado para seu e-email.");
        setServerError("");
        setFormData({ email: "" });
      } else {
        setServerError(result.msg || "Erro ao recuperar senha.");
        setSuccessMessage("");
      }
    } catch (error) {
      console.error("Erro ao recuperar senha:", error);
      setServerError("Erro inesperado. Tente novamente mais tarde.");
      setSuccessMessage("");
    }
    finally {
      setLoading(false);
    }
  };

  const isFormValid =
    formData.email && !errors.email

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="image-section">
          <div className="image-content">
            <img
              src={loginIllustration}
              alt="Login illustration"
              className="login-image"
            />
            <div className="carousel-indicators">
              <svg
                width="89"
                height="16"
                viewBox="0 0 89 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8.5" cy="8" r="8" fill="#4285F3"></circle>
                <circle cx="32.5" cy="8" r="8" fill="#C6DCFF"></circle>
                <circle cx="56.5" cy="8" r="8" fill="#C6DCFF"></circle>
                <circle cx="80.5" cy="8" r="8" fill="#C6DCFF"></circle>
              </svg>
            </div>
          </div>
        </div>
        <div className="form-section">
          <div className="form-container">
            <form className="login-form-wrapper" onSubmit={handleSubmit}>
              <div className="form-header">
                <div className="form-title">Recuperação de Senha</div>
                <div className="form-subtitle">
                  Entre com seu e-mail para continuar
                </div>
              </div>

              <div className="form-content">
                <div className="form-fields">
                  <div className="form-field">
                    <div className="field-label">E-mail:</div>
                    <div className={`input-container ${errors.email ? "input-error" : ""}`}>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Digite seu melhor e-mail"
                        className="form-input"
                      />
                    </div>
                    {errors.email && <div className="error-message">{errors.email}</div>}
                  </div>
                  {successMessage && (
                    <div className="success-message">
                      {successMessage}
                    </div>
                  )}
                </div>

                {serverError && <div className="error-message">{serverError}</div>}

                <div className="form-actions">
                  <button
                    type="submit"
                    className={`login-button ${!isFormValid || loading ? "button-disabled" : ""}`}
                    disabled={!isFormValid || loading}
                  >
                    {loading ? "Enviando..." : "Enviar"}
                  </button>
                  <div className="signup-section">
                    <div className="signup-text">Já possui conta?</div>
                    <button
                      type="button"
                      className="signup-link"
                      onClick={() => navigate("/login")}
                    >
                      Voltar para o login
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecoverForm;
